import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

export function NotImplemented() {
  return (
    <Box sx={{ textAlign: 'center', p: 8 }}>
      <Typography variant="h4" gutterBottom>
        Not implemented yet
      </Typography>
      <Typography color="text.secondary" gutterBottom>
        This page is under construction.
      </Typography>
      <Button component={Link} to="/" variant="contained" sx={{ mt: 2 }}>
        Back home
      </Button>
    </Box>
  );
}
